export default "__VITE_ASSET__x$8r4NUm__"